import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoginComponent} from './login/login.component';
import {RegisterComponent} from './register/register.component';
import {ReactiveFormsModule} from '@angular/forms';
import {AuthRoutingModule} from './auth-routing.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RegistrationRestService} from "../../api/services/registration.rest.service";
import {ResetPasswordComponent} from './reset-password/reset-password.component';
import {ResetConfirmationComponent} from './reset-confirmation/reset-confirmation.component';
import {RegistrationConfirmationComponent} from './registration-confirmation/registration-confirmation.component';
import {
  CompleteRegistrationComponent
} from './complete-registration/complete-registration.component';
import {InputTextModule} from "primeng/inputtext";
import {CheckboxModule} from "primeng/checkbox";
import {ButtonModule} from "primeng/button";
import {RippleModule} from "primeng/ripple";
import {AuthComponent} from './auth.component';
import {BackgroundResolverService} from "../../core/services/background.resolver.service";
import {SharedModule} from "../../shared/shared.module";
import {SpinnerModule} from "../../shared/spinner/spinner.module";
import {InvitationComponent} from "./invitation/invitation.component";
import {OwnerChangeComponent} from "./owner-change/owner-change.component";
import {DenyInvitationComponent} from "./deny-invitation/deny-invitation.component";
import {DenyOwnerChangeComponent} from "./deny-owner-change/deny-owner-change.component";
import {InputOtpModule} from "primeng/inputotp";
import {RegistrationCheckEmailComponent} from "./registration-check-email/registration-check-email.component";

@NgModule({
  declarations: [
    LoginComponent,
    RegisterComponent,
    ResetPasswordComponent,
    ResetConfirmationComponent,
    RegistrationConfirmationComponent,
    CompleteRegistrationComponent,
    RegistrationCheckEmailComponent,
    AuthComponent,
    InvitationComponent,
    OwnerChangeComponent,
    DenyInvitationComponent,
    DenyOwnerChangeComponent
  ], imports: [
    CommonModule,
    AuthRoutingModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    InputTextModule,
    CheckboxModule,
    ButtonModule,
    RippleModule,
    SharedModule,
    SpinnerModule,
    InputOtpModule
  ],
  providers: [
    RegistrationRestService,
    BackgroundResolverService
  ]
})
export class AuthModule {
}
